import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=3d3eb0aa&scoped=true&lang=pug"
import script from "./Impressum.vue?vue&type=script&lang=js"
export * from "./Impressum.vue?vue&type=script&lang=js"
import style0 from "./Impressum.vue?vue&type=style&index=0&id=3d3eb0aa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3eb0aa",
  null
  
)

export default component.exports